import { McpScope } from '@masters-club/types';
import { Badge } from '@/components/ui/badge';
import { scopeLabel, type McpTokenStatus } from '../format';

/** Бейджи scopes: «Чтение» / «Запись». */
export function ScopeBadges({ scopes }: { scopes: string[] }) {
  return (
    <div className="flex flex-wrap gap-1">
      {scopes.map((scope) => (
        <Badge
          key={scope}
          variant={scope === McpScope.WRITE ? 'default' : 'secondary'}
          className={scope === McpScope.WRITE ? 'bg-amber-500/15 text-amber-700 dark:text-amber-400' : undefined}
        >
          {scopeLabel(scope)}
        </Badge>
      ))}
    </div>
  );
}

/** Бейдж статуса токена. */
export function TokenStatusBadge({ status }: { status: McpTokenStatus }) {
  if (status === 'active') {
    return (
      <Badge variant="secondary" className="text-green-600 dark:text-green-400">
        Активен
      </Badge>
    );
  }
  if (status === 'expired') {
    return <Badge variant="outline">Истёк</Badge>;
  }
  return <Badge variant="destructive">Отозван</Badge>;
}

/** Бейдж HTTP-статуса вызова: &lt;400 — зелёный, иначе красный. */
export function HttpStatusBadge({ status }: { status: number }) {
  const ok = status < 400;
  return (
    <Badge
      variant="outline"
      className={ok ? 'border-green-500/40 text-green-600 dark:text-green-400' : 'border-red-500/40 text-red-600 dark:text-red-400'}
    >
      {status}
    </Badge>
  );
}
